const tokenHolder: { token?: string } = {};

export const saveToken = (token: string): void => {
  tokenHolder.token = token;
};

export const getToken = (): string | undefined => tokenHolder.token;
